// torontoDate.js
// All comparisons are done on Toronto calendar dates (YYYY-MM-DD)

const torontoFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Toronto",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export const torontoTodayKey = () => torontoFormatter.format(new Date()); // "YYYY-MM-DD"

export const keyToUTCDate = (key) => {
  // key is "YYYY-MM-DD"
  const [y, m, d] = key.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d, 0, 0, 0, 0));
};

export const dayDiffToronto = (aKey, bKey) => {
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.round((keyToUTCDate(aKey) - keyToUTCDate(bKey)) / msPerDay);
};

export const formatDayLabelToronto = (key, withMonth = false) => {
  const todayKey = torontoTodayKey();
  const diff = dayDiffToronto(key, todayKey);

  if (diff === 0) return "Today";
  if (diff === -1) return "Yesterday";
  if (diff === 1) return "Tomorrow";

  const [y, m, d] = key.split("-").map(Number);
  const noonUTC = new Date(Date.UTC(y, m - 1, d, 12, 0, 0)); // stable label
  return noonUTC
    .toLocaleDateString("en-US", {
      weekday: "short",
      day: "numeric",
      ...(withMonth && { month: "short" }),
      timeZone: "America/Toronto",
    })
    .toUpperCase();
};
